import React from 'react'
import { ReactComponent as Gift } from '../../../../assets/icons/gift.svg'
import { ReactComponent as User } from '../../../../assets/icons/user.svg'
import { ReactComponent as Calendar } from '../../../../assets/icons/calendar.svg'
import { ReactComponent as Credit } from '../../../../assets/icons/credit-card.svg'
import { bool, string } from 'prop-types'
import { PLANO_ANUAL, PLANO_TRIMESTRAL } from '../../../../constants'

const SvgRowText = ( { plan } ) => {
  const getPlanInstallments = () => {
    if ( plan.toLowerCase() === PLANO_ANUAL.slug ) {
      return '12x'
    } else if ( plan.toLowerCase() === PLANO_TRIMESTRAL.slug ) {
      return '3x'
    } else {
      return '1x'
    }
  }

  return (
    <>
      <div className="icon-paragraph">
        <User />

        <p>
          As informações de entrega serão as mesmas cadastradas no plano.{' '}

          <span style={{ 'fontWeight': 600 }}>
            Mantenha seu cadastro atualizado.
          </span>
        </p>
      </div>

      <div className="icon-paragraph">
        <Credit />

        <p>
          {`Será utilizado o seu cartão de crédito vigente e o parcelamento será
          em ${getPlanInstallments()}.`}
        </p>
      </div>

      <div className="icon-paragraph">
        <Calendar />

        <p>
          Você pode alterar a sua data de renovação até o dia 10 do mês da
          cobrança.
        </p>
      </div>

      <div className="icon-paragraph">
        <Gift />

        <p>
          Você vai continuar ganhando um brinde exclusivo em toda renovação!
        </p>
      </div>
    </>
  )
}

SvgRowText.propTypes = {
  'credit': bool,
  'gift': bool,
  'mail': bool,
  'pin': bool,
  'plan': string.isRequired,
  'slash': bool,
}

SvgRowText.defaultProps = {
  'credit': false,
  'gift': false,
  'mail': false,
  'pin': false,
  'slash': false,
}

export default SvgRowText
